import React from "react";
import Helmet from "react-helmet";
import SEO from "../components/SEO";
import "../assets/css/App.css";
import "../assets/css/index.css";
import Layout from "../components/Layout";
import { Jumbotronv2 } from "../components/Jumbotronv2";
import { Link } from "gatsby";
import { ServicesBlock2 } from "../components/ServicesBlock2";
import { RE } from "../components/Reviews";
import { ContactForm } from "../components/ContactForm";
import { Brands } from "../components/Branding";

export default () => (
  <Layout>
    <SEO
      title="Commercial Gas Certificates London | BBIS Heating"
      description="BBIS Heating can help with your Landlord Gas Safety Certificates in your properties around London. Contact us today."
      keywords="commercial gas certificates london,commercial gas certificates potters bar, commercial gas certificates hertfordshire, commercial gas certificates central london"
    />
    <div>
    <Jumbotronv2 imgName="j2"  headingTag={"Commercial Gas Safety Certificates"} descriptionTag={"Gas safety inspections for offices, shops, residential lettings and more across London, Hertfordshire and surrounding areas"} showOverlay={true} />
    </div>
    <div class="white-segment text-left">
      <h2 class="heading-color pb-2">
        Ensure your property is safe and compliant
      </h2>
      <p>
        If your premises uses gas appliances, you’re legally required to hold a
        valid Gas Safety Certificate. Whether you manage an office, shop,
        restaurant, school, warehouse or rental property, our Gas Safe engineers
        carry out thorough inspections to ensure your gas systems are operating
        safely and efficiently.
      </p>
      <p>
        We can also complete your gas safety inspection during your{" "}
        <Link to="/commercial-boiler-servicing/">annual boiler service</Link>{" "}
        for added convenience.
      </p>
    </div>
    <div class="grey-segment text-left">
      <h2 class="heading-color">
        Gas safety checks for landlords and commercial property owners
      </h2>
      <p>
        Landlords and commercial property owners must obtain an annual Gas
        Safety Certificate (CP12) to meet legal requirements. This applies to a
        wide range of properties, including:
      </p>
      <ul class="pb-2">
        <li>Short- and long-term lets</li>
        <li>HMOs and shared accommodation</li>
        <li>Student housing and halls of residence</li>
        <li>Boarding schools</li>
        <li>Airbnb and holiday lets</li>
        <li>
          Commercial premises such as offices, shops, and hospitality venues
        </li>
      </ul>
      <h2 class="heading-color">Why choose BBIS Commercial Heating</h2>
      <ul class="pb-4">
        <li>Same or next working day repair service</li>
        <li>5-star ratings and reviews</li>
        <li>50 years of experience in domestic and commercial heating </li>
        <li>Friendly local commercial boiler engineers in London</li>
      </ul>
      <ServicesBlock2 />
      <Brands/>
    </div>
    <div class="white-segment text-left">
      <h3 class="heading-color">What our customers say</h3>
      <RE />
      <h3 className="heading-color">
        We provide commercial heating services all over London, Hertfordshire
        and the surrounding areas
      </h3>
      <p>
        With over 50 years of experience in the domestic and commercial heating
        industry, get in contact today to find out how we can help.
      </p>
      <ContactForm />
    </div>
  </Layout>
);
